import axios from 'axios'
import store from '../store'

const cancelationTokens = {
  getDocuments: null,
  getArchive: null
}
let checkUserTimeOut
axios.defaults.baseURL = '/api/'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.response.use(
  function (response) {
    clearTimeout(checkUserTimeOut)
    checkUserTimeOut = setTimeout(function () {
      store.dispatch('GET_USER_INFO')
    }, 1000 * 1800)
    return Promise.resolve(response)
  },
  function (error) {
    if (error?.response?.status === 401) {
      store.dispatch('CLEAR_USER_INFO')
      location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default {
  post: {
    login (creds) {
      return axios.post(
        '/login',
        JSON.stringify({
          login: creds.email,
          password: creds.password,
          rememberMe: creds.remember,
          csrf_token: creds.token
        })
      )
    },
    register (accountInfo) {
      return axios.post(
        '/register',
        JSON.stringify({
          username: accountInfo.email,
          email: accountInfo.email,
          firstname: accountInfo.firstName,
          lastname: accountInfo.lastName,
          customer: accountInfo.customerName,
          telephone: accountInfo.telephone,
          password: [accountInfo.password, accountInfo.password2]
        })
      )
    },
    inviteUser (inviteInfo) {
      return axios.post(
        '/users',
        JSON.stringify({
          email: inviteInfo.email,
          role: inviteInfo.role
        })
      )
    },
    resetPassword (email) {
      return axios.post(
        '/resetting/send-email',
        JSON.stringify({
          username: email
        })
      )
    },
    activateUser (userId) {
      return axios.post(
        `/users/${userId}`,
        JSON.stringify({
          enabled: true
        })
      )
    },
    deactivateUser (userId) {
      return axios.post(
        `/users/${userId}`,
        JSON.stringify({
          enabled: false
        })
      )
    },
    updateCustomerInfo (customerId, customerInfo) {
      return axios.post(
        `/customers/${customerId}`,
        customerInfo
      )
    },
    updateInvitedUser (token, userInfo) {
      return axios.post(
        `/resetting/invite/${token}`,
        JSON.stringify({
          password: [userInfo.password, userInfo.password2],
          firstname: userInfo.firstName,
          lastname: userInfo.lastName
        })
      )
    },
    restorePassword (token, passInfo) {
      return axios.post(
        `/resetting/reset/${token}`,
        JSON.stringify({
          password: [passInfo.password, passInfo.password2]
        })
      )
    },
    updateUser (userId, userInfo) {
      return axios.post(`/users/${userId}`, JSON.stringify(userInfo))
    },
    createTask (taskInfo) {
      return axios.post('/tasks', JSON.stringify(taskInfo))
    },
    createRequest (requestInfo) {
      return axios.post('/requests', JSON.stringify(requestInfo))
    },
    sendFeedback (message) {
      return axios.post('/users/feedback', JSON.stringify({ message }))
    },
    addClient (clientInfo) {
      return axios.post(
        '/clients',
        JSON.stringify({
          client_name: clientInfo.clientName,
          client_email: clientInfo.clientEmail,
          client_telephone: clientInfo.clientPhone,
          client_description: clientInfo.clientDescription,
          company_id: clientInfo.legalEntity,
          ad_agent: clientInfo.adAgent
        })
      )
    },
    updateClient (clientInfo, customerId) {
      return axios.post(
        `/clients/${customerId}`,
        JSON.stringify({
          client_name: clientInfo.clientName,
          client_email: clientInfo.clientEmail,
          client_telephone: clientInfo.clientPhone,
          client_description: clientInfo.description,
          company_id: clientInfo.legalEntity,
          ad_agent: clientInfo.adAgent
        })
      )
    },
    addCompany (company) {
      return axios.post(
        '/clients/legal-entity',
        company
      )
    },
    updateCompany (company, leid) {
      return axios.post(
        `/clients/legal-entity/${leid}`,
        company
      )
    },
    sendComments (taskId, comment) {
      return axios.post(
        `/task/${taskId}/comments`,
        JSON.stringify({
          comment: comment
        })
      )
    },
    updateCommentsReadDate (taskId) {
      return axios.post(`/task/${taskId}/comments/read`)
    },
    updateTaskStatus (taskId, status) {
      return axios.post(
        `/tasks/${taskId}`,
        JSON.stringify({
          status: status
        })
      )
    },
    updateLocalTaskStatus (taskId, status, role) {
      return axios.post(
        `/tasks/${taskId}/status`,
        JSON.stringify({
          status: status,
          role: role
        })
      )
    },
    updateTask (taskId, taskInfo) {
      return axios.post(`/tasks/${taskId}`, JSON.stringify(taskInfo))
    },
    updateRequest (requestId, requestInfo) {
      return axios.post(`/requests/${requestId}`, JSON.stringify(requestInfo))
    },
    addTaskLayout (taskId, layoutInfo) {
      return axios.post(`/task/${taskId}/layouts`, JSON.stringify(layoutInfo))
    },
    updateTaskLayout (taskId, layoutId, layoutsInfo) {
      return axios.post(`/task/${taskId}/layouts/${layoutId}`, JSON.stringify(layoutsInfo))
    },
    addPrintMachine (printMachine) {
      return axios.post(
        '/calculator/print-machines',
        JSON.stringify(printMachine)
      )
    },
    editPrintMachine (printMachineId, printMachine) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}`,
        JSON.stringify(printMachine)
      )
    },
    createPrintMachineOperation (printMachineId, operation) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/operation`,
        JSON.stringify(operation)
      )
    },
    updatePrintMachineOperation (printMachineId, operation) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/operation/${operation.id}`,
        JSON.stringify(operation)
      )
    },
    saveOrUpdatePrintMachineOperation (printMachineId, operationId, settings) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/operation/${operationId}/settings`,
        JSON.stringify(settings)
      )
    },
    createPrintMachineProduct (printMachineId, product) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products`,
        JSON.stringify(product)
      )
    },
    updatePrintMachineProduct (printMachineId, product) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products/${product.id}`,
        JSON.stringify(product)
      )
    },
    savePrintMachineFormat (printMachineId, format) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/formats`,
        JSON.stringify(format)
      )
    },
    createPrintMachineProductSection (printMachineId, productId, name) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products/${productId}/sections`,
        JSON.stringify({ name })
      )
    },
    updatePrintMachineProductSection (printMachineId, productId, sectionId, name) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}`,
        JSON.stringify({ name })
      )
    },
    createPrintMachineProductSectionBlock (printMachineId, productId, sectionId, block) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}/blocks`,
        JSON.stringify(block)
      )
    },
    updatePrintMachineProductSectionBlock (printMachineId, productId, sectionId, blockId, block) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}/blocks/${blockId}`,
        JSON.stringify(block)
      )
    },
    updatePrintMachineProductSectionBlockPosition (printMachineId, productId, sectionId, blockId, position) {
      return axios.post(
        `/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}/blocks/${blockId}`,
        JSON.stringify({ position })
      )
    },
    printMachineCalculate (calculateData) {
      return axios.post(
        '/calculator/print-machines/calculating',
        JSON.stringify(calculateData)
      )
    },
    removeFromBasket (checkedItems) {
      return axios.post('/calculator/print-machines/calculating/basket/delete',
        JSON.stringify({ checked_items: checkedItems })
      )
    },
    updateProfile (profile) {
      return axios.post('/profile',
        JSON.stringify(profile)
      )
    },
    addFinanceAccount (account) {
      return axios.post('/finance/accounts', JSON.stringify(account))
    },
    updateFinanceAccount (accountId, account) {
      return axios.post(`/finance/accounts/${accountId}`, JSON.stringify(account))
    },
    applyFinanceDiscount (taskId, discount) {
      return axios.post(`/task/${taskId}/finance_discount`, JSON.stringify({ discount }))
    },
    addInvoice (invoice) {
      return axios.post('/finance/invoices', JSON.stringify(invoice))
    },
    cancelInvoice (fiid, canceled, description) {
      return axios.post(`/finance/invoices/${fiid}/canceled`, JSON.stringify({ canceled, description }))
    },
    invoices (filter) {
      return axios.post('/finance/get-invoices', JSON.stringify({ filter }))
    },
    reportManager (filter) {
      return axios.post('/finance/reports/manager', JSON.stringify({ filter }))
    },
    reportClient (filter) {
      return axios.post('/finance/reports/client', JSON.stringify({ filter }))
    },
    reportProduction (filter) {
      return axios.post('/finance/reports/production', JSON.stringify({ filter }))
    },
    createFastDeal (data) {
      return axios.post('/tasks/quick', JSON.stringify({ data }))
    },
    adAgentPrintMachines (clientId, activePrintMachines) {
      return axios.post(`/settings/ad-agent/${clientId}`, JSON.stringify({ activePrintMachines }))
    },
    addDocumentLayout (model) {
      return axios.post('/documents/layouts', model)
    },
    editDocumentLayout (id, model) {
      return axios.post(`/documents/layouts/${id}`, model)
    },
    addDocumentFromTask (model) {
      return axios.post('/documents/addToTask', model)
    },
    editDocument (id, body) {
      return axios.post(`/documents/${id}`, { body })
    },
    sendDocumentByEmail (id, email) {
      return axios.post(`/documents/${id}/email`, { sendTo: email })
    },
    getDocuments (data) {
      if (cancelationTokens.getDocuments) {
        cancelationTokens.getDocuments.cancel('Operation canceled due to new request.')
      }

      cancelationTokens.getDocuments = axios.CancelToken.source()

      const body = { ...data, skip: 0, limit: 1000 }

      return axios.post('/documents/view', body, { cancelToken: cancelationTokens.getDocuments.token })
    },
    finishedTasks (data) {
      if (cancelationTokens.getArchive) {
        cancelationTokens.getArchive.cancel('Operation canceled due to new request.')
      }

      cancelationTokens.getArchive = axios.CancelToken.source()

      const body = { ...data }

      return axios.post('/tasks/archive', body, { cancelToken: cancelationTokens.getArchive.token })
    },
    sessionBusy (email) {
      return axios.post('/session-busy', { email })
    }
  },
  get: {
    login () {
      return axios.get('/login')
    },
    logout () {
      return axios.get('/logout')
    },
    profile () {
      return axios.get('/profile')
    },
    users () {
      return axios.get('/users')
    },
    companyUsers (cid) {
      return axios.get(`/users?cid=${cid}`)
    },
    user (userId) {
      return axios.get(`/users/${userId}`)
    },
    customers () {
      return axios.get('/customers')
    },
    customerInfo (customerId) {
      return axios.get(`/customers/${customerId}`)
    },
    activateUsers (customerId) {
      return axios.get(`/customers/${customerId}/users/activate/`)
    },
    deactivateUsers (customerId) {
      return axios.get(`/customers/${customerId}/users/deactivate/`)
    },
    deleteUser (userId) {
      return axios.get(`/users/${userId}/delete`)
    },
    invitedUser (token) {
      return axios.get(`/resetting/invite/${token}`)
    },
    userFromResetPassword (token) {
      return axios.get(`/resetting/reset/${token}`)
    },
    confirmEmail (token) {
      return axios.get(`/register/confirm/${token}`)
    },
    allTasks () {
      return axios.get('/tasks/all')
    },
    activeTasks () {
      return axios.get('/tasks')
    },
    outgoingTasks () {
      return axios.get('/requests')
    },
    task (taskId) {
      return axios.get(`/tasks/${taskId}`)
    },
    request (requestId) {
      return axios.get(`/requests/${requestId}`)
    },
    convertRequestToTask (requestId) {
      return axios.get(`/requests/${requestId}/to-task`)
    },
    deleteRequest (requestId) {
      return axios.get(`/requests/${requestId}/delete`)
    },
    clients () {
      return axios.get('/clients')
    },
    companies () {
      return axios.get('/clients/legal-entity')
    },
    company (leid) {
      return axios.get(`/clients/legal-entity/${leid}`)
    },
    companyClients (leid) {
      return axios.get(`/clients/legal-entity-clients/${leid}`)
    },
    activityStream () {
      return axios.get('/activity')
    },
    loadComments (taskId) {
      return axios.get(`/task/${taskId}/comments`)
    },
    getCommentsReadDate (taskId) {
      return axios.get(`/task/${taskId}/comments/read`)
    },
    getProfile () {
      return axios.get('/profile')
    },
    getTaskHistory (taskId) {
      return axios.get(`/tasks/${taskId}/activity`)
    },
    getTaskLayouts (taskId) {
      return axios.get(`/task/${taskId}/layouts`)
    },
    deleteTaskLayout (taskId, layoutId) {
      return axios.get(`/task/${taskId}/layouts/${layoutId}/delete`)
    },
    taskInvoices (taskId) {
      return axios.get(`task/${taskId}/finance_invoices`)
    },
    printMachines () {
      return axios.get('/calculator/print-machines')
    },
    printMachine (printMachineId) {
      return axios.get(`/calculator/print-machines/${printMachineId}`)
    },
    printMachineOperations (printMachineId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/operations`)
    },
    printMachineOperation (printMachineId, operationId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/operation/${operationId}`)
    },
    deletePrintMachine (printMachineId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/delete`)
    },
    deletePrintMachineOperation (printMachineId, operationId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/operation/${operationId}/delete`)
    },
    loadAlgorithms () {
      return axios.get('/calculator/algorithms/operation')
    },
    loadProductAlgorithms () {
      return axios.get('/calculator/algorithms/product')
    },
    operationSettings (printMachineId, operationId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/operation/${operationId}/settings`)
    },
    printMachineProducts (printMachineId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products`)
    },
    printMachineProduct (printMachineId, productId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products/${productId}`)
    },
    deletePrintMachineProduct (printMachineId, productId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products/${productId}/delete`)
    },
    loadPrintMachineFormats (printMachineId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/formats`)
    },
    deletePrintMachineFormat (printMachineId, formatId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/formats/${formatId}/delete`)
    },
    printMachineProductSections (printMachineId, productId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products/${productId}/sections`)
    },
    printMachineProductSection (printMachineId, productId, sectionId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}`)
    },
    deletePrintMachineProductSections (printMachineId, productId, sectionId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}/delete`)
    },
    deletePrintMachineProductSectionsBlock (printMachineId, productId, sectionId, blockId) {
      return axios.get(`/calculator/print-machines/${printMachineId}/products/${productId}/sections/${sectionId}/blocks/${blockId}/delete`)
    },
    calculatedBasket () {
      return axios.get('/calculator/print-machines/calculating/basket')
    },
    addToBasket (key) {
      return axios.get(`/calculator/print-machines/calculating/to-basket/${key}`)
    },
    financeAccounts () {
      return axios.get('/finance/accounts')
    },
    financeAccount (accountId) {
      return axios.get(`/finance/accounts/${accountId}`)
    },
    reportFinanceAccount (date) {
      return axios.get(`/finance/reports/account?date=${date}`)
    },
    sendEmailToClient (taskId) {
      return axios.get(`/tasks/${taskId}/send-email`)
    },
    storageFiles () {
      return axios.get('/file-manager/list')
    },
    documentPlaceholders () {
      return axios.get('/documents/placeholders')
    },
    documentLayouts () {
      return axios.get('/documents/layouts')
    },
    documentLayout (id) {
      return axios.get(`/documents/layouts/${id}`)
    },
    clientDocuments (tid) {
      return axios.get(`/documents/reusable/task/${tid}`)
    },
    taskDocuments (tid) {
      return axios.get(`/documents/task/${tid}`)
    },
    document (id) {
      return axios.get(`/documents/${id}`)
    },
    activateCustomer (id) {
      return axios.get(`/customers/${id}/users/activate`)
    },
    deactivateCustomer (id) {
      return axios.get(`/customers/${id}/users/deactivate`)
    },
    plans () {
      return axios.get('billing-plans')
    },
    defaultPrintMachines () {
      return axios.get('/calculator/default-print-machines')
    },
    copyPrintMachine (pmid) {
      return axios.get(`/calculator/print-machines/${pmid}/copy/full`)
    }
  },
  delete: {
    deleteFiles (fileIds) {
      return axios.delete('/file-manager/delete', { data: { keys: fileIds } })
    },
    documentLayout (id) {
      return axios.delete(`/documents/layouts/${id}`)
    },
    document (id) {
      return axios.delete(`/documents/${id}`)
    }
  }
}
